import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styling/GamesPage.css';

const gamesData = [
  {
    id: 1,
    title: 'A Fun Endless Platformer',
    bio: 'An endless platformer where every jump counts! Embark on a thrilling adventure as you leap across ever-changing landscapes, dodge obstacles, and collect coins. Discover power-ups like Time Saver, Spring Jump, and Shield—each offering unique advantages to tackle new challenges and open up fresh possibilities as you test your reflexes at every turn.',
    image1: '/power.PNG',
    image2: '/endless.PNG',
    logo: '/logo.png',
    appStoreUrl: '' // Replace with your actual URL.
  },
  {
    id: 2,
    title: 'Coming Soon...',
    bio: 'Stay tuned for more exciting gameplay details coming soon!',
    image: '/cover-image.jpg'
  },
];

function GamesPage() {
  const mainGame = gamesData[0];
 // const otherGames = gamesData.slice(1);

  return (
    <section className="games-section">
      <div className='container'>
        <div className='row'>
          <div className='col-4 d-none d-md-flex'>
            <img src={mainGame.logo} alt="logo-image" className='logo-image'/>
          </div>
          <div className='col-8 d-none d-md-flex'>
            <h2>Power Jump: Skybound</h2>
          </div>
          <div className='col-12 d-block d-md-none'>
          <img src={mainGame.logo} alt="logo-image" className='logo-image'/>
          </div>
        </div>
        {/* Main Game Section */}
        <div className="row main-game">
          <div className="col-12 col-lg-6 main-game-text">
            <h3>{mainGame.title}</h3>
            <p>{mainGame.bio}</p>
            <a 
              href={mainGame.appStoreUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn cta-button"
            >
              <strong>Get it on the IOS App Store</strong>
            </a> 
          </div>
          <div className="col-lg-6 d-none d-lg-flex main-game-images">
            <img 
              src={mainGame.image1} 
              alt={`${mainGame.title} screenshot 1`} 
              className="img-fluid game-screenshot1"
            />
            <img 
              src={mainGame.image2} 
              alt={`${mainGame.title} screenshot 2`} 
              className="img-fluid game-screenshot1"
            />            
          </div>
          <div className="col-12 d-flex d-lg-none main-game-images-mobile">
            <img 
              src={mainGame.image1} 
              alt={`${mainGame.title} screenshot 1`} 
              className="img-fluid game-screenshot1"
            />
            <img 
              src={mainGame.image2} 
              alt={`${mainGame.title} screenshot 2`} 
              className="img-fluid game-screenshot1"
            />            
          </div>
        </div>
      </div>
    </section>
  );
}

export default GamesPage;
